<template>
    <div>

        <div ref="d_chart" class="d_chart">

        </div>
    </div>
</template>

<script>

    import ApexCharts from "apexcharts";
    import {formatTripStatus} from '../../utils/formatters';

    export default {
        name: "chart_view",
        computed: {
            deliveryAggregates: function() {
                //status aggregate
                return {
                    COMPLETED: this.trips.filter(item => item.status == "COMPLETED").length/this.trips.length,
                    CANCELLED: this.trips.filter(item => item.status == "CANCELLED").length/this.trips.length,
                    IN_PROGRESS: this.trips.filter(item => item.status == "IN_PROGRESS").length/this.trips.length,
                    PARTIALLY_COMPLETED: this.trips.filter(item => item.status == "PARTIALLY_COMPLETED").length/this.trips.length,
                }
            }
        },
        props: {
            trips: Array,
            updateFilter: Function,
            filterValue: String,
        },
        mounted() {

            const that = this;
            const d_chart = this.$refs.d_chart;
            const statusCodes = Object.keys(this.deliveryAggregates);
            const labels = statusCodes.map(key => formatTripStatus(key));
            const series = statusCodes.map(item => this.deliveryAggregates[item]);
            const options = {
                series,
                labels,
                chart: {
                    type: "donut",
                    events: {
                        dataPointSelection: function(event, chartContext, config) {
                            that.updateFilter({name: "filterTrips", value: labels[config.dataPointIndex]});
                        }
                    }
                }
            };

            const chart = new ApexCharts(d_chart, options);
            chart.render();

        }
    }
</script>

<style scoped>

</style>
